// components/FlavorFormSections/FlavorSEOSection.jsx
import React from "react";
import { TextField, Box, Typography } from "@mui/material";

const FlavorSEOSection = ({ formData, setFormData }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="subtitle2" gutterBottom>
        SEO Information
      </Typography>

      <TextField
        fullWidth
        label="Meta Title"
        value={formData.seo.metaTitle}
        onChange={(e) =>
          setFormData({
            ...formData,
            seo: { ...formData.seo, metaTitle: e.target.value },
          })
        }
        sx={{ my: 1 }}
      />

      <TextField
        fullWidth
        label="Meta Description"
        value={formData.seo.metaDescription}
        onChange={(e) =>
          setFormData({
            ...formData,
            seo: { ...formData.seo, metaDescription: e.target.value },
          })
        }
        sx={{ my: 1 }}
        multiline
        rows={3}
      />
    </Box>
  );
};

export default FlavorSEOSection;
